/* src/app/external-user/invoice-details/invoice-status/invoice-status-profile/invoice-status-profile.component.css */
.page-wrapper {
  padding: 2rem 1rem;
  display: flex;
  justify-content: center;
  background: #f5f7fa;
}
.status-card {
  width: 100%;
  max-width: 760px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 4px 18px -4px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.06);
  padding: 2rem 2rem 2.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  border: 1px solid #e5e9f0;
}
.status-card.success {
  border-top: 6px solid #18a558;
}
.status-card.failure {
  border-top: 6px solid #d93025;
}
.card-header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  position: relative;
}
.status-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background:
    linear-gradient(
      135deg,
      #1ec267,
      #18a558);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  flex-shrink: 0;
  box-shadow: 0 4px 10px -2px rgba(24, 165, 88, 0.4);
}
.failure-icon {
  background:
    linear-gradient(
      135deg,
      #f44336,
      #d93025);
  box-shadow: 0 4px 10px -2px rgba(217, 48, 37, 0.4);
}
.status-text .title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: .5px;
  color: #1f2933;
}
.status-text .subtitle {
  margin: .4rem 0 0;
  font-size: .95rem;
  color: #4a5568;
  line-height: 1.4;
}
.print-btn {
  position: absolute;
  top: 0;
  right: 0;
  background: #eef2f7;
  border: none;
  color: #4a5668;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  cursor: pointer;
  transition: all .2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.print-btn:hover {
  background: #dde3eb;
  color: #1f2933;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.divider {
  height: 1px;
  background:
    linear-gradient(
      90deg,
      #e3e8ef,
      #f2f4f7 40%,
      #e3e8ef);
  margin: .25rem 0 .5rem;
}
.section {
  display: flex;
  flex-direction: column;
  gap: .25rem;
}
.section + .section {
  margin-top: .35rem;
}
.section-label {
  font-size: .72rem;
  text-transform: uppercase;
  letter-spacing: 1.1px;
  font-weight: 600;
  color: #667788;
}
.section-value {
  font-size: .92rem;
  font-weight: 500;
  color: #1f2933;
  word-break: break-word;
}
.transIDWordBreak {
  word-break: break-all;
}
.payment-block {
  background: #f8fafc;
  border: 1px solid #e4e9f1;
  border-radius: 12px;
  padding: 1.25rem 1.25rem 1.4rem;
  display: flex;
  gap: 1rem;
  margin-top: .5rem;
  position: relative;
  overflow: hidden;
}
.payment-block::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(
      circle at 85% 15%,
      rgba(24, 165, 88, 0.08),
      transparent 70%);
  pointer-events: none;
}
.payment-icon {
  width: 54px;
  height: 54px;
  border-radius: 12px;
  background:
    linear-gradient(
      135deg,
      #2563eb,
      #1d4ed8);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
  box-shadow: 0 4px 10px -2px rgba(29, 78, 216, 0.4);
}
.payment-info {
  flex: 1;
}
.payment-heading {
  margin: 0 0 .35rem;
  font-size: 1.05rem;
  font-weight: 600;
  color: #1f2933;
  letter-spacing: .4px;
}
.amount-row {
  display: flex;
  flex-direction: column;
  gap: .25rem;
}
.amount-label {
  font-size: .75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #5b6775;
}
.amount-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2933;
  letter-spacing: .5px;
}
.actions {
  display: flex;
  justify-content: flex-end;
  margin-top: .5rem;
}
.action-btn {
  display: inline-flex;
  align-items: center;
  gap: .55rem;
  border: none;
  padding: .85rem 1.4rem .9rem;
  font-size: .95rem;
  font-weight: 600;
  border-radius: 12px;
  cursor: pointer;
  background: #2563eb;
  color: #ffffff;
  letter-spacing: .4px;
  box-shadow: 0 4px 14px -3px rgba(37, 99, 235, 0.55);
  transition: all .22s;
}
.action-btn i {
  font-size: 1.05rem;
}
.action-btn:hover {
  background: #1d4ed8;
  transform: translateY(-2px);
  box-shadow: 0 8px 18px -5px rgba(37, 99, 235, 0.55);
}
.success-btn {
  background:
    linear-gradient(
      135deg,
      #1ec267,
      #18a558);
  box-shadow: 0 4px 14px -3px rgba(24, 165, 88, 0.55);
}
.success-btn:hover {
  background:
    linear-gradient(
      135deg,
      #19b55e,
      #14924d);
}
.failure-btn {
  background:
    linear-gradient(
      135deg,
      #f44336,
      #d93025);
  box-shadow: 0 4px 14px -3px rgba(217, 48, 37, 0.55);
}
.failure-btn:hover {
  background:
    linear-gradient(
      135deg,
      #e5392d,
      #c32319);
}
.icon-btn {
  cursor: pointer;
}
.cursorpointer {
  cursor: pointer;
}
@media (max-width: 640px) {
  .status-card {
    padding: 1.5rem 1.25rem 2rem;
  }
  .payment-block {
    flex-direction: row;
  }
  .action-btn {
    width: 100%;
    justify-content: center;
  }
  .card-header {
    padding-right: 48px;
  }
  .print-btn {
    top: -4px;
    right: -4px;
  }
}
/*# sourceMappingURL=invoice-status-profile.component.css.map */
